import React from 'react';
import type Simulation from '../../../interfaces/simulation/simulation';
import { getSimulation } from '../../../services/simulation/simulation';

// Simulation de l'URL, partagee entre AppSimulation (affichage du menu
// d'arbitrage de masse) et les features (dont le contenu peut etre rendu dans
// une autre racine React), pour ne la charger qu'une fois. L'ecran
// d'elaboration y publie sa propre simulation (plus complete, avec la periode
// affichee), qui remplace la version legere
let simulationCourante: Simulation | null = null;
let chargementEnCours: Promise<Simulation> | null = null;
const abonnes = new Set<() => void>();

export const setSimulationCourante = (simulation: Simulation) => {
	if (simulationCourante === simulation) return;

	simulationCourante = simulation;
	abonnes.forEach((abonne) => {
		abonne();
	});
};

// Charge la simulation seule (avec son budget), sans les imputations, si elle
// n'est pas deja connue ; les appels simultanes partagent la meme requete
export const chargerSimulationCourante = (identifiant: number) => {
	if (simulationCourante) return Promise.resolve(simulationCourante);

	chargementEnCours ??= getSimulation(
		identifiant,
		new URLSearchParams({ withBudget: 'true' }),
	)
		.then((simulation) => {
			// La simulation de l'ecran d'elaboration a pu etre publiee entre-temps
			if (!simulationCourante) setSimulationCourante(simulation);

			return simulationCourante;
		})
		.finally(() => {
			chargementEnCours = null;
		});

	return chargementEnCours;
};

const subscribe = (abonne: () => void) => {
	abonnes.add(abonne);

	return () => {
		abonnes.delete(abonne);
	};
};

// Le selecteur permet de ne re-rendre que si la valeur lue change (ex: pas a
// chaque saisie de montant dans l'ecran d'elaboration)
export const useSimulationCourante = <T = Simulation | null>(
	selecteur: (simulation: Simulation | null) => T = (simulation) =>
		simulation as T,
) => React.useSyncExternalStore(subscribe, () => selecteur(simulationCourante));
